module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEJSURBVEhL7ZNBagJBFEQHAt7AVcxG9Czigdya8wi6EhXJJbyDuFSiGxfCaJU+R6Ujdo/uzINPz9SvX39omOy92AOvryPP87ZqTP7ez9ZoP4eCvlU52QXWRBdbORTgLw/Cz7gnWtjT0fCErLvIM8aeBvPRMBYPc9Ewlo6uYOMAnTUka19oa6TyKGRA2NBLHK4aofWxlUchTdXSgddIW+moY3sOhX2qeqq1Qn919lUN2u+KruKDR1/Rj2qh2lJza7RvvA+RuaLhjkOQ7v4TtP0BXtiRVEH6G5mqqtlp/BLAawDtou9ZZyCHqDnFewQ5eoFxBnKImjt8R5BTF+yQQ/AUICctMMj/xJBlBzJide7vH/RoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-worker/light/24.png
// module id = 2584
// module chunks = 2